"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogout = void 0;
const react_1 = require("react");
const TokenAuthContext_1 = __importDefault(require("./TokenAuthContext"));
const useFetchCallType_1 = __importDefault(require("./useFetchCallType"));
const useLogout = () => {
    const { setIsSignout } = react_1.useContext(TokenAuthContext_1.default);
    const [logout, { loading: logoutLoading }] = useFetchCallType_1.default('Logout', {
        skip: true,
        onCompleted: () => setIsSignout(true),
    });
    return {
        logout,
        logoutLoading,
    };
};
exports.useLogout = useLogout;
